/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { ItemResponseType } from './ItemResponseType';
import {
    ItemResponseTypeFromJSON,
    ItemResponseTypeFromJSONTyped,
    ItemResponseTypeToJSON,
    ItemResponseTypeToJSONTyped,
} from './ItemResponseType';

/**
 * 
 * @export
 * @interface PortalItemResponse
 */
export interface PortalItemResponse {
    /**
     * 
     */
    response: ItemResponseType;
    /**
     * 
     */
    note: string | null;
    /**
     * 
     */
    other_contact: string | null;
    /**
     * 
     */
    updated_at: Date;
}



/**
 * Check if a given object implements the PortalItemResponse interface.
 */
export function instanceOfPortalItemResponse(value: object): value is PortalItemResponse {
    if (!('response' in value) || value['response'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    if (!('other_contact' in value) || value['other_contact'] === undefined) return false;
    if (!('updated_at' in value) || value['updated_at'] === undefined) return false;
    return true;
}

export function PortalItemResponseFromJSON(json: any): PortalItemResponse {
    return PortalItemResponseFromJSONTyped(json, false);
}

export function PortalItemResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalItemResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'response': ItemResponseTypeFromJSON(json['response']),
        'note': json['note'],
        'other_contact': json['other_contact'],
        'updated_at': (json['updated_at'] == null ? json['updated_at'] : parseDateTime(json['updated_at'])),
    };
}

export function PortalItemResponseToJSON(json: any): PortalItemResponse {
    return PortalItemResponseToJSONTyped(json, false);
}

export function PortalItemResponseToJSONTyped(value?: PortalItemResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'response': ItemResponseTypeToJSON(value['response']),
        'note': value['note'],
        'other_contact': value['other_contact'],
        'updated_at': value['updated_at'] == null ? value['updated_at'] : serializeDateTime(value['updated_at']),
    };
}

